import * as React from "react";

const format = (time: number) => {
  const hrs = Math.floor(time / 3600);
  const mins = Math.floor((time % 3600) / 60);
  const secs = time % 60;

  return `${hrs.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

export const useDocumentStopwatchTitle = (
  seconds: number,
  projectAccumulatedSeconds: number,
  baseTitle = "Collab",
) => {
  React.useEffect(() => {
    const total = projectAccumulatedSeconds + seconds;
    document.title =
      total > 0
        ? `${baseTitle} - ${format(seconds)} - ${format(total)}`
        : baseTitle;
  }, [seconds, projectAccumulatedSeconds, baseTitle]);
};

